<template>
    <div>
        <pleitos
            :pleitosServicos="obterDataServicos()"
            rotaDetalhar="Pleitos_Financeiro_Detalhar"
            rotaListagem="Pleitos_Financeiro"
            rotaInserir="Pleitos_Financeiro_Inserir"
            rotaAtualizar="Pleitos_Financeiro_Atualizar"
            :temAcessoDetalhar="$temAcessoView('PLEITOS-FINAN-00')"
            :permiteInserir="$temAcessoView('PLEITOS-FINAN-01')"
            :permiteAtualizar="$temAcessoView('PLEITOS-FINAN-01')"
            :permiteExcluir="$temAcessoView('PLEITOS-FINAN-02')"
        ></pleitos>
        <router-view></router-view>
    </div>
</template>

<script>
import PleitosServicos from './PleitosServicos'
import Pleitos from '../componentes/PleitosLista'

export default {
    components: {
        Pleitos
    },

    methods: {
        obterDataServicos() {
            return PleitosServicos
        }
    },
}
</script>

